import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-footer-sm',
    templateUrl: './footer-sm.component.html',
    styleUrls: ['./footer-sm.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterSmComponent implements OnInit {


  constructor() { }

  ngOnInit(): void {
  }

}
